import { DefaultPaymentOption } from 'store/api/types';

// The requisites form edits one payment option but cannot say which: the `set`
// mutation carries no id, so the server applies it to the organization's
// default option. The list arrives ordered by name, so taking the first entry
// would show one option and save into another — a save then copied the shown
// BIC and account number over the default option, destroying its own values.
// Reading the same option the server writes to keeps the two in step.
export const selectEditablePaymentOption = (
  payments: DefaultPaymentOption[] | undefined,
): DefaultPaymentOption | undefined =>
  payments?.find((payment) => payment.isDefault) ?? payments?.[0];
